export const noticeStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 32px',
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const noticeIconStyles = {
  display: 'flex',
  color: 'text.secondary',
};
